<template>
	<b-row>
		<b-col>
			<h4 class="mt-2">Abilities</h4>
			<b-list-group>

				<b-list-group-item>
					<h5>Race</h5>
					<ul class="list-inline mb-0">
						<li class="list-inline-item" v-for="(ability, abilityID) in Character.Bio.Race.Properties" :key="'racial-'+abilityID">{{ability.Name}}</li>
					</ul>
				</b-list-group-item>

				<b-list-group-item>
					<h5>Theme</h5>
					<ul class="list-inline mb-0">
						<li class="list-inline-item" v-for="(levelData, level) in previousLevels" :key="'theme-'+level">
							<span v-if="levelData.Theme !== undefined">{{levelData.Theme.Name}}</span>
						</li>
					</ul>
				</b-list-group-item>

				<b-list-group-item>
					<h5>Feats</h5>
					<ul class="list-inline mb-0" v-for="(levelData, level) in previousLevels" :key="'feat-'+level">
						<li class="list-inline-item" v-if="levelData.Feats.length > 0"><strong>{{level|ordinal}}</strong></li>
						<li class="list-inline-item" v-for="(feat, index) in levelData.Feats" :key="'feat-'+level+'-'+index">{{feat.Name}}</li>
					</ul>
				</b-list-group-item>

				<b-list-group-item>
					<h5>Class</h5>
					<ul class="list-inline mb-0" v-for="(levelData, level) in previousLevels" :key="'class-'+level">
						<li class="list-inline-item" v-if="levelData.Abilities.length > 0"><strong>{{level|ordinal}}</strong></li>
						<li class="list-inline-item" v-for="(ability, abilityID) in levelData.Abilities" :key="'class-'+level+'-'+abilityID">{{ability.Name}}</li>
					</ul>
				</b-list-group-item>

			</b-list-group>
		</b-col>
	</b-row>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
	computed: {
		Character: function() {
			return this.$store.state.Character
		},
		...mapGetters([
			'previousLevels'
		]),
	}
}
</script>

<style scoped>

</style>